import { useNavigate } from 'react-router-dom'
import { Trophy, ArrowRight } from 'lucide-react'
import { Card, CardContent } from '@/components/ui/card'
import { Button } from '@/components/ui/button'
import { EstadoConexionBadge } from './EstadoConexionBadge'
import type { ConfiguracionFidelizacionListItem } from '../types'

interface Props {
  configuracion: ConfiguracionFidelizacionListItem
}

export function ReporteCard({ configuracion: c }: Props) {
  const navigate = useNavigate()

  return (
    <Card className="border border-gray-300 dark:border-gray-700 bg-gradient-to-r from-blue-500/15 via-blue-500/5 via-50% to-transparent dark:from-blue-800/20 dark:via-blue-900/10 dark:via-50% dark:to-transparent">
      <CardContent className="p-5">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-start gap-3 min-w-0">
            <div className="flex h-10 w-10 items-center justify-center rounded-md bg-blue-500/10 shrink-0">
              <Trophy className="h-5 w-5 text-blue-500" />
            </div>
            <div className="min-w-0">
              <p className="text-base font-semibold text-black dark:text-white truncate">{c.nombre}</p>
              <p className="text-xs text-muted-foreground truncate">{c.grupo_nombre}</p>
            </div>
          </div>
          <EstadoConexionBadge ultimoUso={c.ultimo_uso} ultimoError={c.ultimo_error} activo={c.activo} />
        </div>

        <div className="mt-4 flex items-center justify-between text-xs text-muted-foreground">
          <span className="truncate">{c.api_base_url}</span>
        </div>

        <div className="mt-4 flex justify-end">
          <Button
            size="sm"
            onClick={() => navigate(`/reportes-fidelizacion/${c.id}`)}
            disabled={!c.activo}
            className="bg-blue-800 hover:bg-blue-900 text-white"
          >
            Abrir reporte
            <ArrowRight className="ml-2 h-4 w-4" />
          </Button>
        </div>
      </CardContent>
    </Card>
  )
}
